import { addTransition } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledSliderDot = styled.button<{ isSelected?: boolean }>`
	${(p) => css`
		padding: 0;
		border: none;

		width: 8px;
		height: 8px;

		margin-left: 6px;

		&:nth-child(1) {
			margin-left: 0;
		}

		border-radius: 50%;

		background-color: ${p.theme.colors.white};

		cursor: pointer;

		border: 1px solid ${p.theme.colors.gold};

		${p.isSelected
			? css`
					${addTransition(undefined, undefined, 0.1)}
					opacity: 1;
					transform: rotateY(-180deg);
			  `
			: css`
					${addTransition()}
					opacity: 0.5;
					transform: rotateY(-0deg);
			  `}
	`}
`;
